export default {
  filterBy: '14062018-122247-9820',

  roomPosition: '20052026-131733-1182',
  externalView: '01122021-112529-0001',
  internalView: '24022026-152225-7376',

  configuration: '23122019-153433-0069',
  boardRoom: '08062017-153116-6431',
  cabaret: '23122019-211721-0000',
  classroom: '23122019-211721-0023',
  data: '23122019-211721-0052',
  theatre: '23122019-152459-0030',
  uShape: '23122019-152459-0058',

  apply: '17112016-112904-6361',
  clearAll: '17112016-111036-0681'
};
